//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'SI',
  data() {
    return {
      defaultJson:{
        "Heart Rate": "心率",
        "Systolic Blood Pressure": "收缩压",
      },
      form:{
        sbp:'',
        hr:'',
      },
      hasScore:false,
      disabled:false
    }
  },
  rqed () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key]=='---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '...'
      } else {
        // hr / sbp
        let res =  form.hr / form.sbp
        self.res = res.toFixed(2)
        self.hasScore = true
        return String(self.res)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/ObGyn/SI.vue